import { AuthConnection } from "@/api/config.js";

/** common */
export function getEnums() {
  return AuthConnection().get(`/enums`);
}

/** health check */
export function healthCheck() {
  return AuthConnection().get(`/app/health`);
}
